jq('document').ready(() => {
    const nav_search_btn = document.getElementById('nav-search-toggle');
    const nav_search_el = document.getElementById('submenu-search-form');
    const nav_search_query = document.querySelector('.nav-search-input');
    if (nav_search_btn && nav_search_el && nav_search_query) {
        nav_search_btn.addEventListener('click', () => {
            const expanded = nav_search_btn.getAttribute('aria-expanded') == 'true';
            nav_search_btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            nav_search_el.classList.toggle('active');
        });
        nav_search_query.addEventListener('keydown', (evt) => {
            if (evt.key == "Escape") {
                nav_search_btn.setAttribute('aria-expanded', 'false');
                nav_search_el.classList.remove('active');
                nav_search_query.blur();
            }
        });
    }

    // Focus fix
    const dropdown_items = document.querySelectorAll('.has-children ul li a');
    dropdown_items.forEach((nav_item) => {
        nav_item.addEventListener('keydown', (evt) => {
            if (evt.key == "Escape") {
                nav_item.blur();
            }
        });
    });

    const backlinks = document.querySelectorAll('.news-backlink');
    backlinks.forEach((backlink) => {
        backlink.addEventListener('click', () => {
            history.back();
        });
    });

    const aboutNewsFilterForm = document.getElementById('about-news-tag-filter');
    if (aboutNewsFilterForm) {
        aboutNewsFilterForm.addEventListener('submit', (evt) => {
            const selectField = aboutNewsFilterForm.querySelector('.eq-select');
            const currentOption = selectField.options[selectField.selectedIndex];
            if (currentOption.classList.contains('redirect')) {
                evt.preventDefault();
                window.location.href = selectField.value;
            }
        });
    }

    // Remove extraneous logos from PRs
    let pr_images = document.querySelectorAll('.xn-content .PRN_ImbeddedAssetReference');
    pr_images.forEach((pr_image) => {
        let img = pr_image.querySelector('img');
        if (img && img.getAttribute('src').toLowerCase().indexOf('logo') !== -1) {
            pr_image.remove();
        }
    });

    // Remove empty anchor tags from article elements
    const articles = document.querySelectorAll('article');
    articles.forEach((article) => {
        const emptyLinks = article.querySelectorAll('a');
        emptyLinks.forEach((link) => {
            // Check if link is empty (no text content, no meaningful innerHTML)
            const textContent = link.textContent.trim();
            const innerHTML = link.innerHTML.trim();
            // Consider it empty if there's no text and no meaningful HTML content
            if (!textContent && (!innerHTML || innerHTML === '')) {
                link.remove();
            }
        });
    });

    const tab_navs = document.querySelectorAll('.tab-header .nav-item > button');
    tab_navs.forEach((btn) => {
        const target = document.getElementById(btn.dataset.target.slice(1));
        const links = target.querySelectorAll('a');
        btn.addEventListener('keydown', (evt) => {
            if (evt.key == 'Tab' && !evt.shiftKey && btn.classList.contains('active')) {
                evt.preventDefault();
                links[0].focus();
            }
            if (evt.key == 'Tab' && !evt.shiftKey && !btn.classList.contains('active') && btn.parentElement.classList.contains('last')) {
                const active_links = btn.closest('.text').querySelectorAll('.tab-pane.active a');
                active_links[active_links.length - 1].focus();
            }
        });
        links[links.length - 1].addEventListener('keydown', (evt) => {
             if (evt.key == 'Tab' && !evt.shiftKey && !btn.parentElement.classList.contains('last')) {
                btn.focus();
             }
        });
    });

    const contact_forms_module = document.querySelector('.module-contact-form-select');
    const contact_form_options = document.getElementById("contactFormOptions") ? JSON.parse(document.getElementById("contactFormOptions").innerText) : '';
    if (contact_forms_module) {
        const form_selection = document.getElementById('contact-form-select');
        form_selection.onchange = (evt) => {
            const target_form = document.getElementById(evt.target.value);
            const forms = document.querySelectorAll('.form-wrapper');
            forms.forEach((form) => {
                form.classList.remove('active');
            });
            target_form.classList.add('active');
        };
        const sales_form_selection = document.getElementById('sales-form-select');
        sales_form_selection.onchange = (evt) => {
            if (evt.target.value !== 'redirect') {
                const target_form = document.getElementById('sales-form-' + evt.target.value);
                const forms = document.querySelectorAll('#sales-form .embed-wrapper');
                forms.forEach((form) => {
                    form.classList.remove('active');
                });
                target_form.classList.add('active');
            } else {
                const redirect = evt.target.options[evt.target.selectedIndex].innerText.trim().toLowerCase();
                const redirect_url = contact_form_options['redirects'][redirect];
                if (redirect_url) {
                    window.open(redirect_url);   
                }
            }
        };
    }

    const popup_buttons = document.querySelectorAll('.popup-btn');
    popup_buttons.forEach((btn) => {
        const target = document.getElementById(btn.dataset.target);
        const focus_items = target.querySelectorAll('a, button');
        focus_items.forEach((focus_item) => {
            focus_item.setAttribute('tabindex', '-1');
        });
        btn.addEventListener('click', () => {
            if (!target) {
                return false;
            }
            const is_hidden = target.getAttribute('aria-hidden') == 'true';
            focus_items.forEach((focus_item) => {
                if (is_hidden) {
                    focus_item.removeAttribute('tabindex');
                } else {
                    focus_item.setAttribute('tabindex', '-1');
                }
            });
            target.setAttribute('aria-hidden', is_hidden ? 'false' : 'true');
            btn.setAttribute('aria-expanded', is_hidden ? 'true' : 'false');

            // Shift focus to the first focusable item for screen readers
            if (is_hidden && focus_items.length > 0) {
                focus_items[0].focus();
            }

            // Add Escape key listener only when popup is shown
            if (is_hidden) {
                const escHandler = (e) => {
                    if (e.key === 'Escape') {
                        // Hide popup
                        target.setAttribute('aria-hidden', 'true');
                        btn.setAttribute('aria-expanded', 'false');

                        // Remove focus from popup items
                        focus_items.forEach((focus_item) => {
                            focus_item.setAttribute('tabindex', '-1');
                        });

                        // Return focus to the button
                        btn.focus();

                        // Remove this event listener
                        document.removeEventListener('keydown', escHandler);
                    }
                };
                document.addEventListener('keydown', escHandler);
            }
        });
    });
    

    // Footnotes and Reference links generation
    // Generates footnote links per module
    // Uses the following attributes
    // data-footnote-module-id: number, row id of the module
    // data-footnote-ref: number, footnote id you want the tag to link to
    // data-footnote: number, footnote id
    /*
    const footnote_modules = document.querySelectorAll('[data-footnote-module-id]');
    footnote_modules.forEach((footnote_module) => {
        const module_id = footnote_module.dataset.footnoteModuleId;
        const footnote_refs = footnote_module.querySelectorAll('[data-footnote-ref]');
        const footnotes = footnote_module.querySelectorAll('[data-footnote]');
        if (!footnote_refs || !footnotes) {
            return false;
        }
        footnote_refs.forEach((ref) => {
            const ref_text = ref.innerText;
            const footnote_id = ref.dataset.footnoteRef;
            const footnote_link = document.createElement('a');
            footnote_link.innerText = ref_text;
            footnote_link.setAttribute('aria-label', `Reference to footnote ${footnote_id}`);
            let ref_id = `module-${module_id}-footnote-${footnote_id}-ref`;
            let ref_count = 1;
            while (document.getElementById(ref_id)) {
                ref_id = `module-${module_id}-footnote-${footnote_id}-ref-${ref_count++}`;
            }
            footnote_link.setAttribute('href', `#module-${module_id}-footnote-${footnote_id}`);
            ref.replaceChildren(footnote_link);
            add_anchor_span(ref, ref_id);
        });
        footnotes.forEach((footnote) => {
            const footnote_id = `module-${module_id}-footnote-${footnote.dataset.footnote}`;
            if (document.getElementById(footnote_id)) {
                console.error(`Duplicate footnote detected: Module ${module_id}, Footnote ${footnote.dataset.footnote}`);
                return;
            }
            add_anchor_span(footnote, footnote_id);
            const references = document.querySelectorAll(`[href="#${footnote_id}"]`);
            references.forEach((reference_link, index) => {
                const link_back = document.createElement('a');
                link_back.innerText = '⮑';
                link_back.setAttribute('href', '#' + reference_link.previousElementSibling.getAttribute('id'));
                let return_aria_label = `Return to footnote ${footnote.dataset.footnote} reference`;
                if (references.length > 1) {
                    return_aria_label += ` ${index + 1}`;
                }
                link_back.setAttribute('aria-label', return_aria_label);
                link_back.classList.add('link-back');
                footnote.insertAdjacentElement('beforeend', link_back);
            });
        });
    });
    */
    const footnote_modules = document.querySelectorAll('[data-footnote-module-id]');
    footnote_modules.forEach((footnote_module) => {
        const module_id = footnote_module.dataset.footnoteModuleId;
        const footnote_refs = footnote_module.querySelectorAll('[data-footnote-ref]');
        const footnotes = footnote_module.querySelectorAll('[data-footnote]');
        if (!footnote_refs || !footnotes) return;
    
        footnote_refs.forEach((ref) => {
            const ref_text = ref.innerText;
            const footnote_id = ref.dataset.footnoteRef;
            const footnote_link = document.createElement('a');
            footnote_link.innerText = ref_text;
            footnote_link.setAttribute('aria-label', `Reference to footnote ${footnote_id}`);
            let ref_id = `module-${module_id}-footnote-${footnote_id}-ref`;
            let ref_count = 1;
            while (document.getElementById(ref_id)) {
                ref_id = `module-${module_id}-footnote-${footnote_id}-ref-${ref_count++}`;
            }
            footnote_link.setAttribute('href', `#module-${module_id}-footnote-${footnote_id}`);
            ref.replaceChildren(footnote_link);
            add_anchor_span(ref, ref_id);
        });
    
        footnotes.forEach((footnote) => {
            const footnote_key = footnote.dataset.footnote;
            const footnote_id = `module-${module_id}-footnote-${footnote_key}`;
            if (document.getElementById(footnote_id)) {
                console.error(`Duplicate footnote detected: Module ${module_id}, Footnote ${footnote_key}`);
                return;
            }
            add_anchor_span(footnote, footnote_id);
    
            const references = document.querySelectorAll(`[href="#${footnote_id}"]`);
            if (references.length > 0) {
                const first_ref = references[0];
                const link_back = document.createElement('a');
                link_back.innerText = '⮑';
                const back_target = first_ref.previousElementSibling?.getAttribute('id');
                if (back_target) {
                    link_back.setAttribute('href', `#${back_target}`);
                    link_back.setAttribute('aria-label', `Return to footnote ${footnote_key} reference`);
                    link_back.classList.add('link-back');
                    footnote.insertAdjacentElement('beforeend', link_back);
                }
            }
        });
    });

    // scrolling table indicators
    const tables = document.querySelectorAll('.table-contents');
    tables.forEach((table) => {
        const table_wrap = table.parentElement;
        if (table.scrollWidth - table.clientWidth > 0) {
            table_wrap.classList.add('fade-right');
        }
        table_resize_check(table, table_wrap);
        window.addEventListener('resize', () => {
            table_resize_check(table, table_wrap);
        });
        table.addEventListener('scroll', () => {
            const max_scroll = table.scrollWidth - table.clientWidth - 1;
            const scroll_pos = table.scrollLeft;
            if (scroll_pos > 1) {
                table_wrap.classList.add('fade-left');
            } else {
                table_wrap.classList.remove('fade-left');
            }
            if (scroll_pos < max_scroll) {
                table_wrap.classList.add('fade-right');
            } else {
                table_wrap.classList.remove('fade-right');
            }
        });
    });
    
    const anchor_nav_toggle = document.getElementById('anchor-nav-toggle');

    if (anchor_nav_toggle) {
        anchor_nav_toggle.addEventListener('click', () => {
            const target = anchor_nav_toggle.parentElement;
            const menu = document.getElementById('anchor-list');
            const menu_links = menu.querySelectorAll('a');
            target.classList.toggle('closed');
            if (target.classList.contains('closed')) {
                anchor_nav_toggle.setAttribute('aria-expanded', 'false');
                menu.setAttribute('aria-hidden', 'true');
                menu_links.forEach((link) => {
                    link.setAttribute('tabindex', '-1');
                });
            } else {
                anchor_nav_toggle.setAttribute('aria-expanded', 'false');
                menu.setAttribute('aria-hidden', 'false');
                menu_links.forEach((link) => {
                    link.removeAttribute('tabindex');
                });
            }
        });
    }
    const polaroids = document.querySelectorAll('.polaroid');
    if (polaroids) {
        polaroids.forEach(polaroid => {
            const originalSrc = polaroid.querySelector('img').src;
            const hoverSrc = polaroid.getAttribute('data-hover');
            polaroid.addEventListener('mouseenter', () => {
                polaroid.querySelector('img').src = hoverSrc;
            });
            polaroid.addEventListener('mouseleave', () => {
                polaroid.querySelector('img').src = originalSrc;
            });
        });
    }

    /*
    const counters = document.querySelectorAll('.count-row .num');
    if (counters) {
        const counter_intervals = [];
        counters.forEach((counter) => {
            const interval = setInterval(() => {
                let target = Number.parseInt(counter.dataset.target);
                let current = Number.parseInt(counter.innerText.replace(/,/g, ''));
                current += 1;
                counter.innerText = current.toLocaleString();
                if (current >= target) {
                    clearInterval(interval);
                }
            }, 50);
            counter_intervals.push(interval);
        });
    }
    */
    
    // Pause / Start counter animation
    const counters = document.querySelectorAll('.count-row .num');
    const controlBtn = document.querySelector('.stat-animation-control-btn');
    const counterIntervals = [];
    const initialValues = [];
    let isAnimating = true;
    let activeAnimations = 0;

    // Store initial values
    counters.forEach(counter => {
        initialValues.push(counter.innerText);
    });

    function startAnimationCounter() {
        isAnimating = true;
        controlBtn.setAttribute('aria-label', 'Pause Animation');

        counters.forEach((counter, index) => {
            counter.innerText = initialValues[index]; // Reset to initial value
            const target = Number.parseInt(counter.dataset.target);
            let current = Number.parseInt(counter.innerText.replace(/,/g, ''));

            activeAnimations += 1;

            const interval = setInterval(() => {
                if (!isAnimating) {
                    clearInterval(interval);
                    counter.innerText = target.toLocaleString(); // Set to final value
                    return;
                }

                current += 1;
                counter.innerText = current.toLocaleString();

                if (current >= target) {
                    clearInterval(interval);
                    activeAnimations -= 1;

                    // If all animations are done, update button to "play"
                    if (activeAnimations === 0) {
                        isAnimating = false;
                        controlBtn.setAttribute('aria-label', 'Start Animation');
                        controlBtn.classList.add('paused');
                    }
                }
            }, 50);

            counterIntervals[index] = interval;
        });
    }

    function stopAnimationCounter() {
        isAnimating = false;
        controlBtn.setAttribute('aria-label', 'Start Animation');

        counterIntervals.forEach((interval, index) => {
            clearInterval(interval);
            const target = Number.parseInt(counters[index].dataset.target);
            counters[index].innerText = target.toLocaleString(); // Set to final value
        });

        activeAnimations = 0;
    }

    if (controlBtn) {
        controlBtn.addEventListener('click', () => {
            controlBtn.classList.toggle('paused');
            if (isAnimating) {
                stopAnimationCounter();
            } else {
                startAnimationCounter();
            }
        });
        // Start animation on page load
        startAnimationCounter();
        // end of Pause / Start counter animation
    }

    const waitUntil = (conditionFn, callback) => {
        let attempts = 0;
        const maxAttempts = 15; 
        
        const interval = setInterval(() => {
            if (conditionFn()) {
                clearInterval(interval);
                callback();
                return;
            }
            
            attempts++;
            if (attempts >= maxAttempts) {
                clearInterval(interval);
                console.warn('Max attempts reached for waitUntil');
                return;
            }
        }, 300);
    }

    // Banner slider play/pause button controls
    const playPauseBtn = document.getElementById('sliderPlayPause');
    if (playPauseBtn && jq('.banner-slider').length) {
        let isPlaying = true;
        
        waitUntil(() => {
            return jq('.banner-slider').hasClass('slick-initialized');
        }, () => {
            playPauseBtn.addEventListener('click', function() {
                const iconSpan = this.querySelector('.material-icons');
                const srOnlySpan = this.querySelector('.sr-only');
                
                if (isPlaying) {
                    jq('.banner-slider').slick('slickPause');
                    if (iconSpan) iconSpan.textContent = 'play_arrow';
                    this.setAttribute('aria-label', 'Start automatic slide show');
                    this.setAttribute('title', 'Start automatic slide show');
                    if (srOnlySpan) srOnlySpan.textContent = 'Start automatic slide show';
                } else {
                    jq('.banner-slider').slick('slickPlay');
                    if (iconSpan) iconSpan.textContent = 'pause';
                    this.setAttribute('aria-label', 'Stop automatic slide show');
                    this.setAttribute('title', 'Stop automatic slide show');
                    if (srOnlySpan) srOnlySpan.textContent = 'Stop automatic slide show';
                }
                isPlaying = !isPlaying;
            });
        });
    }
}); // End document.ready

function table_resize_check(table, table_wrap) {
    const max_scroll = table.scrollWidth - table.clientWidth - 1;
    if (max_scroll > 1) {
        const scroll_pos = table.scrollLeft;
        if (scroll_pos > 1) {
            table_wrap.classList.add('fade-left');
        }
        if (scroll_pos < max_scroll) {
            table_wrap.classList.add('fade-right');
        }
        table_wrap.classList.add('fade-right');
    } else {
        table_wrap.classList.remove('fade-left', 'fade-right');
    }
}

// Adds an anchor span as the first child of an element to aid in proper positioining when going to anchor links
function add_anchor_span(element, id) {
    const anchor_span = document.createElement('span');
    anchor_span.classList.add('anchor');
    anchor_span.setAttribute('id', id);
    element.insertAdjacentElement('afterbegin', anchor_span);
}

// Handle URL hash and parameters to open specific tab
document.addEventListener('DOMContentLoaded', function() {
    // Method 1: Handle URL hash (e.g., #tab123)
    const hash = window.location.hash;
    if (hash) {
        const tabButton = document.querySelector(`[data-target="${hash}"]`);
        if (tabButton) {
            tabButton.click();
            return; // Exit early if hash is found
        }
    }
    
    // Method 2: Handle URL parameters (e.g., ?tab=123)
    const urlParams = new URLSearchParams(window.location.search);
    const tabId = urlParams.get('tab');
    if (tabId) {
        const tabButton = document.querySelector(`[data-target="#tab${tabId}"]`);
        if (tabButton) {
            tabButton.click();
        }
    }
});


